module.exports = __webpack_public_path__ + "img/ic_pool.261093c1.png";